import type { KeyframeRule, StyleRule } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';
import { pxArrayToRem } from '@archipro-design/aria';
import { svgIconClassName } from '@archipro-design/icons';

export const ShippingForm: StyleRule = ({ theme }) => ({
    fontSize: theme.siteVariables.fontSizes['label01'],
    overflow: 'hidden auto',
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    '&::-webkit-scrollbar': {
        width: pxToRem(6),
    },
    '&::-webkit-scrollbar-track': {
        backgroundColor: theme.siteVariables.colors.white[300],
    },
    '&::-webkit-scrollbar-thumb:vertical': {
        backgroundColor: theme.siteVariables.colors.charcoal['250'],
    },

    [theme.screen.tablet]: {
        maxHeight: pxToRem(376),
    },
});

export const MethodContainer: StyleRule = ({ theme }) => ({
    position: 'relative',
    flexGrow: 1,
    gap: pxToRem(41),
    [theme.screen.tablet]: {
        display: 'grid',
        gridTemplateColumns: pxArrayToRem([340, 340]),
        columnGap: theme.siteVariables.spaces['space-24'],
        alignItems: 'flex-start',
        minHeight: pxToRem(120),
    },
});

export const RotateKeyframes: KeyframeRule = () => ({
    from: {
        transform: 'rotate(0deg)',
    },
    to: {
        transform: 'rotate(360deg)',
    },
});

export const Overlay: StyleRule<{ rotateKeyframes: string }> = ({
    theme,
    rotateKeyframes,
}) => ({
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    maxWidth: pxToRem(841),
    ['& .' + svgIconClassName]: {
        animation: `${rotateKeyframes} linear 1500ms infinite`,
        width: pxToRem(64),
        height: pxToRem(64),
        fill: theme.siteVariables.colors.white[300],
    },
});

export const Suburb: StyleRule = ({ theme }) => ({
    margin: pxArrayToRem([12, 0, 41, 0]),
    [theme.screen.tablet]: {
        margin: pxArrayToRem([32, 48, 32, 0]),
    },
});
